import Api from '@project/Api';
import consts from '@project/consts';
import {useState} from 'react';

const useFetchSbpList = ({orderId, setShownModal, shownModal, onClose}) => {
  const [error, setError] = useState(null);

  const showSbpList = (platformValue) => {
    setError('');

    Api.get(consts.API_METHODS.SBP_BANKS, {
      query: {
        id: orderId,
        platform: platformValue,
      },
    })
      .then((response) => {
        setShownModal({
          type: consts.MODAL_TYPES.SELECT_BANK,
          props: {
            shownModal,
            bankList: response,
            onClose,
          },
        });
      })
      .catch((err) => {
        const message =
          err?.message ||
          'При получении списка банков возникла ошибка, пожалуйста попробуйте еще раз или чуть позже.';
        setError(message);
      });
  };

  return {showSbpList, error};
};

export default useFetchSbpList;
